import { useState } from "react";
import parse from "html-react-parser";

const VideoDescription = ({ description }) => {
  const [expanded, setExpanded] = useState(false);
  // Use optional chaining and nullish coalescing to provide a safe default
  const safeDescription = description ?? "";

  // Limit text length for preview (first 250 chars)
  const preview =
    safeDescription.length > 250
      ? safeDescription.slice(0, 250) + "..."
      : safeDescription;

  return (
    <div className="video-description">
      <div className="description-text">
        {expanded ? parse(description) : parse(preview)}
      </div>
      {description?.length > 200 && (
        <button
          className="toggle-description"
          onClick={() => setExpanded(!expanded)}
        >
          {expanded ? "Show Less" : "Show More"}
        </button>
      )}
    </div>
  );
};

export default VideoDescription;
